var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "colored-stroke",
    d: "M21.3447 20.7586C21.3447 21.2342 21.1307 21.6903 20.7498 22.0266C20.3689 22.3628 19.8522 22.5517 19.3135 22.5517H3.06348C2.52476 22.5517 2.0081 22.3628 1.62717 22.0266C1.24623 21.6903 1.03223 21.2342 1.03223 20.7586V8.20692C1.03223 7.73136 1.24623 7.27528 1.62717 6.93901C2.0081 6.60273 2.52476 6.41382 3.06348 6.41382H8.1416L10.1729 9.10347H19.3135C19.8522 9.10347 20.3689 9.29239 20.7498 9.62866C21.1307 9.96493 21.3447 10.421 21.3447 10.8966V20.7586Z",
    stroke: "#6024B8",
    strokeWidth: 1.86207,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "colored-stroke",
    d: "M25.9375 18.0345V5.96555C25.9375 5.48999 25.7235 5.0339 25.3426 4.69763C24.9616 4.36136 24.445 4.17244 23.9062 4.17244H14.7656L12.7344 1.48279H7.65625C7.11753 1.48279 6.60087 1.6717 6.21994 2.00798C5.83901 2.34425 5.625 2.80033 5.625 3.27589V5.20693",
    stroke: "#6024B8",
    strokeWidth: 1.86207,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.aaa959e7.svg";
export { ForwardRef as ReactComponent };